import type { ReactNode } from "react";
import { FloatingCard } from "@/components/primitives/FloatingCard";
import { AppShell } from "./AppShell";

export function AuthLayout({
	title,
	subtitle,
	children,
}: {
	title: string;
	subtitle?: string;
	children: ReactNode;
}) {
	return (
		<AppShell mode="public">
			<div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center px-4 py-10">
				<FloatingCard className="w-full p-6">
					<h1 className="text-xl font-semibold tracking-tight text-fg">{title}</h1>
					{subtitle ? (
						<p className="mt-1.5 text-sm text-fg-muted">{subtitle}</p>
					) : null}
					<div className="mt-6">{children}</div>
				</FloatingCard>
			</div>
		</AppShell>
	);
}
